export const ctripCarTypes = {
  146: "STANDARD",
  117: "STANDARD",
  118: "CARRIER",
  119: "EXECUTIVE",
  121: "LARGE_PEOPLE_CARRIER",
  122: "LARGE_PEOPLE_CARRIER",
  123: "MINI_BUS",
  120: "EXECUTIVE_PEOPLE_CARRIER",
  141: "ELECTRIC_LUXURY",
};

export const getCtripCarType = (categoryId) =>
  ctripCarTypes[String(categoryId)] || null;

export const isOfferRateUpdatable = (categoryId) =>
  Boolean(getCtripCarType(categoryId));
